"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.broaderContentCategoryPropertyDefinition = void 0;
exports.broaderContentCategoryPropertyDefinition = {
    name: 'broader-content-category',
    type: 'asset',
    constraints: [
        {
            name: 'stencils',
            argument: ['content-category', 'collection'],
        },
    ],
    multiple: false,
    view: { label: 'Parent' },
};
const isBroaderContentCategoryProperty = (prop) => {
    return prop.name === exports.broaderContentCategoryPropertyDefinition.name && prop.type === exports.broaderContentCategoryPropertyDefinition.type;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnJvYWRlci1jb250ZW50LWNhdGVnb3J5LnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvYnJvYWRlci1jb250ZW50LWNhdGVnb3J5LnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsd0NBQXdDLEdBQUc7SUFDdEQsSUFBSSxFQUFFLDBCQUEwQjtJQUNoQyxJQUFJLEVBQUUsT0FBTztJQUNiLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsa0JBQWtCLEVBQUUsWUFBWSxDQUFDO1NBQzdDO0tBQ0Y7SUFDRCxRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxRQUFRLEVBQUU7Q0FDTSxDQUFBO0FBSWpDLE1BQU0sZ0NBQWdDLEdBQUcsQ0FBQyxJQUFrQixFQUEwQyxFQUFFO0lBQ3RHLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxnREFBd0MsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLElBQUksS0FBSyxnREFBd0MsQ0FBQyxJQUFJLENBQUE7QUFDbkksQ0FBQyxDQUFBIn0=